import ContribuicaoForm from "../components/ContribuicaoForm";

export default function EventoInternoContribuicaoForm() {
  return (
    <ContribuicaoForm
      rotaVisualizar="/evento-interno/visualizar"
      painelJustificativaExibeRedacao
    />
  );
}
